declare namespace $ {

	export class $mol_icon_align_horizontal_distribute extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=distribute.view.tree.d.ts.map